import * as React from 'react';
import { useContext } from 'react';

import type {
  DescriptionPage_ProductVariant as DescriptionPageProductVariant,
  DescriptionPage_MarketingSource as MarketingSource,
} from '__generated__/graphql-types';

import type PAGE_TYPES from 'bundles/unified-description-page-common/constants/pageTypes';
import { getSpecializationProductUrl } from 'bundles/unified-description-page-common/utils';
import getCourseLink from 'bundles/unified-description-page-common/utils/getCourseLink';

export type PageInfo = {
  getCourseLink: ({ courseSlug, specializationSlug }: { courseSlug: string; specializationSlug?: string }) => string;
  getSpecializationLink: ({
    productSlug,
    productVariant,
  }: {
    productSlug: string;
    productVariant: DescriptionPageProductVariant;
  }) => string;
  productSlug?: string;
  orgSlug?: string;
  marketingSource?: MarketingSource;
  pageType?: (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES];
  navigationIdMap?: Record<string, string>;
  subfolderLocaleCode?: string;
  hasDubbedLanguages?: boolean;
  /**
   * Controls the default `renderInPlace` of UDP modals. When the page is rendered
   * embedded inside another modal (e.g. the My Plan XDP preview), set this to `false`
   * so nested UDP modals portal to `document.body` and overlay the viewport instead
   * of rendering inside the host modal's clipped subtree. Undefined = standalone XDP,
   * where modals keep rendering in place (unchanged, preserves SEO-relevant inline DOM).
   */
  renderModalsInPlace?: boolean;
};

const PageInfoContext = React.createContext<PageInfo>({
  getCourseLink,
  getSpecializationLink: getSpecializationProductUrl,
});

export const usePageInfo = () => {
  return useContext(PageInfoContext);
};

export default PageInfoContext;
